export default __webpack_public_path__ + "static/media/flag-usa-inactive.0eeee482.svg";